import React, {useRef, useState} from "react";
import {ManualBox2} from "../manualsBox/golf-products-manualsBox";

export const tabList = [
  {idx: 1, title : 'Features'},
  {idx: 2, title : 'Description'},
  {idx: 3, title : 'Specifications'},
  {idx: 4, title : 'Manuals'},
]

export const UPL9 = () => {
  const [tabIndex, setTabIndex] = useState<number>(1)
  const scrollRef = [
    useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
  ];

  return (
    <>
      <div className="product_view upl9Mini">
        <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/upl9mini/banner.jpg')"}}>
          <section className="section_0">
            <div className="image-box">
              <div className="text-box">
                <p className="text-01">UPL9</p>
                <p className="text-02">As Small as a Card.<br/>
                  Packed with Performance
                </p>
                <p className="text-03">Lightning-Fast 0.1s Measurement Meets Premium Design</p>
                <ul style={{margin: '25px 0 22px'}}>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_04.png" alt=""/>
                    <p>0.1 sec<br/>
                      Measurement<br/>
                      <span>Lightning‑Fast<br/>Measurement </span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_02.png" alt=""/>
                    <p>Ultra-Lightweight<br/>Card-Sized<br/>
                      <span>Only 3.6oz (103g)</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_03.png" alt=""/>
                    <p>Distance<br/>
                      Triangulation Mode<br/>
                      <span>Ball-to-Pin Distance<br/>Measurement</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_01.png" alt=""/>
                    <p>Continuous<br/>
                      Scan Mode<br/>
                      <span>Quickly Scan<br/>Multiple Targets</span>
                    </p>
                  </li>
                </ul>
                <ul>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_12.png" alt=""/>
                    <p>Slope Mode<br/>
                      <span>Plays‑Like Distance<br/>(On/Off) </span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_10.png" alt=""/>
                    <p>Tournament<br/>
                      Mode<br/>
                      <span>USGA‑Legal with<br/>Slope Off</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_06.png" alt=""/>
                    <p>Pin Finder<br/>
                      with Haptic<br/>
                      Feedback<br/>
                      <span>Vibration Confirms<br/>Flag Lock</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_14.png" alt=""/>
                    <p>6X<br/> Magnification<br/>
                      <span>Gives a Clear View<br/>of the Pin</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_11.png" alt=""/>
                    <p>Long-Range<br/>
                      Measurement<br/>
                      <span>Accurate Yardages<br/>Across the Course</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_09.png" alt=""/>
                    <p>Yard/Meter<br/>Switch<br/>
                      <span>One‑Touch Unit<br/>Switch</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_13.png" alt=""/>
                    <p>Intuitive UX<br/>
                      <span>Simple, One‑Handed<br/>Operation</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_08.png" alt=""/>
                    <p>Rainproof<br/>
                      Design<br/>
                      <span>Ready for<br/>All‑Weather<br/>Rounds</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_07.png" alt=""/>
                    <p>Up to 5,000<br/>
                      Measurements<br/>
                      <span>Per Full Charge –<br/>Lasts an Entire Season<br/>and More</span>
                    </p>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl9mini/upl9_00_15.png" alt=""/>
                    <p>Rechargeable<br/>
                      via USB‑C<br/>
                      <span>No More<br/>BatteryChanges</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <div className="scrollDownBox scrollDownBox2">
            <div>
              <span></span>
            </div>
            <span>SCROLL</span>
          </div>
        </div>
        <div className="tabWrap tabBtnWrapBattery">
          <div className="tabBtnWrap">
            <div className="tabBtnBox">
              {tabList.map((list:{idx:number,title:string})=>(
                <button className={tabIndex===list?.idx?'active':''} onClick={()=>setTabIndex(list?.idx)}>
                  {list?.title}
                </button>
              ))}
            </div>
          </div>

          <div className="tabContentBox">
            {tabIndex === 1 && <div className={`features active`}>
                <section className="section_8">
                    <div className="imgBox">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_08_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_6">
                    <p className="text-01">Smaller Than a Credit Card<br/>Ultra-Compact Design That Fits in Your Pocket</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_06_1464x600.jpg" alt=""/>
                    </div>
                    <p>* For size reference only. Card not included</p>
                </section>

                <section className="section_3">
                    <p className="text-01">A Golf Rangefinder This Compact<br/>Compact Like Never Before.</p>
                    <p className="text-02">Premium materials and a refined design, ergonomic design for a secure grip.</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_18_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_3">
                    <p className="text-01">Distance Triangulation Mode (FineCaddie Mode)</p>
                    <p className="text-02">Measure distance from the cart with <span>3-point triangulation</span></p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_03_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_4">
                    <p className="text-01">When to Use Distance Triangulation Mode (FineCaddie Mode)</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_04_01.png" alt=""/>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_04_02.png" alt=""/>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_04_03.png" alt=""/>
                    </div>
                </section>

                <section className="section_5">
                    <p className="text-01">How to Use Distance Triangulation Mode (FineCaddie Mode)</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_05_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_2">
                    <p className="text-01">Continuous Scan (Scan Mode)</p>
                    <ol>
                        <li><img src="/assets/images/product/upl9mini/1.png" alt="1"/> Hold Power <img src="/assets/images/product/upl9mini/power.png" alt=""/> + Press <img src="/assets/images/product/upl9mini/mode.png" alt=""/> to activate Scan Mode.</li>
                        <li><img src="/assets/images/product/upl9mini/2.png" alt="2"/> Seamlessly track distances to multiple targets in real time.</li>
                        <li><img src="/assets/images/product/upl9mini/3.png" alt="3"/> The blinking crosshair indicates active scanning and real-time updates.</li>
                    </ol>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_02_01.png" alt=""/>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_02_02.png" alt=""/>
                        <div>
                            <p>Functions Available in Scan Mode</p>
                            <div>
                                <dl>
                                    <dt>Available</dt>
                                    <dd>Standard & Pin Finder Modes (Temporary)<br/>
                                        Auto-returns to Scan Mode after 2s.
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Unavailable</dt>
                                    <dd>Slope, Tournament mode,<br/>
                                        and unit switching unavailable.
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <p>＊Use the same method to exit Scan Mode.</p>
                </section>

                <section className="section_1">
                    <p className="text-01">Scan Mode for Continuous Distance Measurement</p>
                    <p className="text-02">Precision from any angle, even on unstable ground. Measure multiple targets easily with a single touch.</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_01_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_11">
                    <p className="text-01">Slope Mode & Tournament Mode</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_11_01.jpg" alt=""/>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_11_02.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_9">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">Steady Target Lock,<br/> Even with Shaky Hands.</p>
                                <p className="text-02">Press and hold the Power Button to scan around the pin.<br/> The device vibrates twice to confirm the distance to the pin.</p>
                                <p className="text-03">Clear Measurement Confirmation</p>
                                <p className="text-04">Pin Finder with Haptic Vibration Alerts</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl9mini/UPL9_en_amazon_09.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_10">
                    <p className="text-01">Bright, Crystal-Clear View for Instant Pin Yardage.</p>
                    <p className="text-02">《6× Wide-View Optical Viewfinder》</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_10_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_15">
                    <p className="text-01">Accurate Measurements Up to 985 Yards (In clear conditions)</p>
                    <p className="text-02">Please note that measurement accuracy may vary depending on weather conditions such as heavy fog, rain, or overcast skies.</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_15_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_14">
                    <p className="text-01">Premium Design for a Refined Game</p>
                    <p className="text-02">Premium leather texture offers a secure, comfortable grip through every hole.</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_14_01.jpg" alt=""/>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_14_02.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_13">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">Long-Lasting Play</p>
                                <p className="text-02">20,000+ Scans per Full Charge</p>
                                <p className="image-01"><img src="/assets/images/product/upl9mini/UPL9_en_amazon_13_01.png" alt=""/></p>
                                <p className="text-03">＊Actual measurement count may vary depending on usage conditions.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl9mini/UPL9_en_amazon_13.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_16">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">USB-C Rechargeable –<br/>
                                    Say Goodbye to Battery Swaps
                                </p>
                                <p className="text-02">Charge Anytime, Anywhere</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl9mini/UPL9_en_amazon_16.jpg" alt=""/>
                        </div>
                    </div>
                </section>
            </div>}
            {tabIndex === 2 && <div className={`whatsInTheBox active`}>
                <section>
                    <div className="imgBox">
                        <h3>Product Description</h3>
                        <img src="/assets/images/product/upl2000/description.jpg" alt="Product Description"/>
                    </div>
                    <div className="imgBox" style={{marginBottom: '30px'}}>
                        <h3>WHAT’S IN THE BOX</h3>
                        <img src="/assets/images/product/upl9mini/UPL9_en_amazon_17_1464x600.jpg" alt="Product Description"/>
                    </div>
                    <ul>
                        <li>※ Check your package contents upon arrival</li>
                        <li>※ Package contents may vary based on product enhancements.</li>
                    </ul>
                </section>
            </div>}
            {tabIndex === 3 && <div className={`specifications active`}>
                <div className="tableWrap">
                    <table>
                        <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>UPL9</th>
                            <th>Remark</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>Size/Weight</th>
                            <td>
                                3.43 x 2.09 x 1.13 in, 3.63 oz (87 x 53 x 28.6 mm, 103g)
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Measuring range</th>
                            <td>
                                3-985 Yards
                            </td>
                            <td>±(1.0yd + D×0.2%)</td>
                        </tr>
                        <tr>
                            <th>Measuring unit</th>
                            <td>m (Meter), Y (Yard)</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Measuring speed</th>
                            <td>54.7yd (50m)</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Magnification</th>
                            <td>6X</td>
                            <td>±5%</td>
                        </tr>
                        <tr>
                            <th>Viewing angle</th>
                            <td>7.5°</td>
                            <td>±5%</td>
                        </tr>
                        <tr>
                            <th>Objective Lens Aperture</th>
                            <td>18 mm</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Eyepiece Aperture</th>
                            <td>16 mm</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Diopter Adjustment Range</th>
                            <td>±6.0dpt</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th rowSpan={2}>Display</th>
                            <td rowSpan={2}>
                                (Inner) High‑transmittance LCD<br/>
                                (External) 1.69 inch TFT LCD
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{borderLeft: '1px solid #EEEEEE'}}></td>
                        </tr>
                        <tr>
                            <th>Laser Spec.</th>
                            <td>Level : Class 1<br/>
                                Wavelength : 905nm<br/>
                                Pulse duration : 54.49ns<br/>
                                Output : &lt;1mW<br/>
                                Beam divergence : 1.5 mrad</td>
                            <td>IEC 60825-1</td>
                        </tr>
                        <tr>
                            <th>Battery Capacity</th>
                            <td>3.7 V / 635 mAh</td>
                            <td>Li-ion</td>
                        </tr>
                        <tr>
                            <th>Battery Life</th>
                            <td>Charging/discharging 500 times</td>
                            <td>Maximum charging time about 1h50m</td>
                        </tr>
                        <tr>
                            <th>Battery Run Time</th>
                            <td>Based on number of laser transmissions : 20,000 measurements<br/>
                                Based on actual field distance measurements<br/>
                                : 5,000 measurements</td>
                            <td>When fully charged</td>
                        </tr>
                        <tr>
                            <th>Waterproof</th>
                            <td>Basic waterproof</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Operation temperature</th>
                            <td>14°F-122°F (-10°C to 50°C)</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Height Measurement</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Pin Finder</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>USB Charging Terminal</th>
                            <td>USB Type-C</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                Model Name : UPL9<br/>
                                Name : Laser golf rangefinder<br/>
                                Manufacturer : FINEDIGITAL INC.<br/>
                                Manufacturing country : China<br/>
                                Date of manufacture : Separately marked<br/>
                                KC Certification Number : R-R-FDK-FineA005<br/>
                                Battery Registration Number : ZU10701-17002U
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>}
            {tabIndex === 4 && <ManualBox2/>}
          </div>
        </div>
      </div>
    </>
  )
}
